import { getKeyWordsHighlight } from './ShellyScriptHelpers';

export default class ShellyScriptHightlight {
	public static highlight(code: string) {
		// console.time("👓 highlight code test speed");
		const nodeList = code.split(''),
			results = [...code.matchAll(ShellyScriptHightlight.getPattern())].reverse(),
			resultLength = results.length;
		for (let i = 0; i < resultLength; i++) {
			const result = results[i];
			let pattern = '';
			Object.keys(result.groups).forEach((k) => {
				if (result.groups[k]) pattern = k;
			});
			let key = result[0];
			if (pattern == 'function') {
				key = key.slice(0, -1);
			}
			const length = key.length;
			const index = result.index;
			const value = `<span class="token ${pattern}">${key
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')}</span>`;
			nodeList.splice(index, length, value);
		}
		// console.timeEnd("👓 highlight code test speed");
		return nodeList.join('');
	}
	public static get patterns() {
		return {
			fullcomment: `(^|[^\\\\])\\/\\*[\\s\\S]*?(?:\\*\\/|$)`,
			comment: `\\/\\/.*`,
			string: `("(.*?[^\\\\])"|'(.*?[^\\\\])'|\`[^\`]*\`)`,
			operator: `[<>]=?|[!=]=?=?|--?|\\+\\+?|&&?|\\|\\|?|[?*/~^%]`,
			number: `\\b0x[\\da-f]+\\b|(?:\\b\\d+(?:\\.\\d*)?|\\B\\.\\d+)(?:e[+-]?\\d+)?`,
			shelly: `\\b(${getKeyWordsHighlight(true).flat().join('|')})\\b`,
			keyword: `\\b(${getKeyWordsHighlight().flat().join('|')})\\b`,
			boolean: `\\b(false|true)\\b`,
			function: `\\b(\\w+)\\(`,
		};
	}
	private static getPattern(): RegExp {
		const patterns = ShellyScriptHightlight.patterns;
		let pattern = '';
		for (const p in patterns) {
			pattern += `(?<${p}>${patterns[p]})|`;
		}
		pattern = pattern.slice(0, -1);
		return RegExp(pattern, 'g');
	}
}
